<template>
    <div :id="'module-title-' + dModule.id">
        <div v-html="dModule.data.content" class="module-text ql-editor"></div>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
    name: "TitleModule",
    props: {
        data: Object,
    },
    data() {
        return {
            dModule: this.data,
        };
    },
};
</script>